import i18next from 'i18next';

const passwordValidationRules = [
  { regex: '[a-zA-Z0-9]+', mandatory: true, messageKey: 'Password_Rules_InvalidCharacter' },
  { regex: '.{8,}', mandatory: true, messageKey: 'Password_Rules_ShortPassword' },
  { regex: '[a-z]+', mandatory: false, messageKey: 'Password_Rules_NoLowercase' },
  { regex: '[A-Z]+', mandatory: false, messageKey: 'Password_Rules_NoUppercase' },
  { regex: '[0-9]+', mandatory: false, messageKey: 'Password_Rules_NoNumbers' },
];
const facultativeRulesCount = 2;

export function getPasswordValidationResult(password: string): string {
  let message = '';
  let matchCount = 0;
  let notMandatoriesMessages: string[] = [];
  let mandatoriesMessages: string[] = [];

  passwordValidationRules.forEach(x => {
    const validationResult = new RegExp(x.regex).test(password);

    if (x.mandatory) {
      if (!validationResult) {
        mandatoriesMessages = [...mandatoriesMessages, i18next.t(x.messageKey as any)];
      }
    } else {
      if (!validationResult) {
        notMandatoriesMessages = [...notMandatoriesMessages, i18next.t(x.messageKey as any)];
      } else {
        matchCount++;
      }
    }
  });

  if (mandatoriesMessages.length > 0) {
    message = i18next.t('Password_Requirement_Mandatory', {
      satisfyRules: mandatoriesMessages.join(', '),
    });
  } else {
    if (matchCount < facultativeRulesCount) {
      const nonSatisfiedCount = facultativeRulesCount - matchCount;
      const allRulesString = notMandatoriesMessages.join(', ');
      message = i18next.t('Password_Requirement', {
        count: nonSatisfiedCount,
        rules: allRulesString,
      });
    }
  }
  return message;
}
